module.exports = __webpack_public_path__ + "demo_anc_q7_1.jpg?9442a607680dc3eca043b6b180846455";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo_anc_q7_1.jpg
// module id = 560
// module chunks = 0